/**
 * Montagem na página do produto: aplica a regra de preço pelo valor total do produto
 * (preço da variante x quantidade), em vez do preço de uma unidade.
 *
 * Regra: até R$ 1.000,00 em produtos cobra R$ 90,00; acima disso, 9%.
 * É a mesma conta do calculateAssemblyPrice original (9% com mínimo de R$ 90),
 * só que sobre o valor total.
 *
 * Não altera o sections/main-product.liquid: ajusta as funções globais que ele cria
 * (calculateAssemblyPrice, getAssemblyPrice, processAssembly). Se elas não existirem,
 * não faz nada e a calculadora original segue funcionando como antes.
 */
(() => {
  const form = document.querySelector('product-form form');
  const botaoCalcular = document.getElementById('assembly-submit-fullcomm');

  if (!form || !botaoCalcular
    || typeof window.calculateAssemblyPrice !== 'function'
    || typeof window.getAssemblyPrice !== 'function'
    || typeof window.processAssembly !== 'function') return;

  const precos = lerPrecosDasVariantes();
  if (!precos) return;

  function lerPrecosDasVariantes() {
    try {
      const json = document.getElementById('AssemblyOfferVariantPrices');
      if (json) return JSON.parse(json.textContent);
    } catch (e) {
      // segue para a alternativa abaixo
    }

    const produto = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    if (!produto || !Array.isArray(produto.variants)) return null;

    return produto.variants.reduce((mapa, variante) => {
      mapa[variante.id] = variante.price;
      return mapa;
    }, {});
  }

  function quantidade() {
    const campo = form.elements.quantity;
    const valor = parseInt(campo && campo.value, 10);
    return valor > 0 ? valor : 1;
  }

  // Valor dos produtos em reais: preço da variante escolhida x quantidade.
  function valorDosProdutos() {
    const campoId = form.elements.id;
    const centavos = campoId ? Number(precos[campoId.value]) : NaN;
    return (Number.isFinite(centavos) ? centavos : 0) * quantidade() / 100;
  }

  // Mesma conta do original, agora sobre o valor total.
  window.calculateAssemblyPrice = function calculateAssemblyPrice() {
    const assemblyPrice = valorDosProdutos() * 0.090;
    return assemblyPrice <= 90 ? 90 : assemblyPrice;
  };

  // Guarda o último endereço consultado para refazer a conta quando a quantidade mudar.
  let ultimoEndereco = null;
  const getAssemblyPriceOriginal = window.getAssemblyPrice;
  window.getAssemblyPrice = function getAssemblyPrice(city, state, neighborhood) {
    ultimoEndereco = { localidade: city, uf: state, bairro: neighborhood };
    return getAssemblyPriceOriginal.apply(this, arguments);
  };

  /**
   * O app de cobrança multiplica o valor da propriedade "Montagem" pela quantidade do item
   * e ignora centavos. Por isso o valor gravado é a parte inteira de cada unidade que deixa
   * o total cobrado mais perto da montagem calculada (em empate, o menor).
   */
  function valorPorUnidade(totalMontagem, qtd) {
    const alvo = Math.floor(totalMontagem);
    const abaixo = Math.floor(alvo / qtd);
    const acima = abaixo + 1;
    return alvo - abaixo * qtd <= acima * qtd - alvo ? abaixo : acima;
  }

  const processAssemblyOriginal = window.processAssembly;
  window.processAssembly = function processAssembly(checkbox) {
    processAssemblyOriginal(checkbox);

    const campo = document.getElementById('assembly-price-fullcomm');
    if (!checkbox.checked || !campo) return;

    const porUnidade = valorPorUnidade(window.calculateAssemblyPrice(), quantidade());
    campo.value = `R$${porUnidade.toFixed(2).replace('.', ',')}`;
  };

  // Quantidade ou variante mudou depois do cálculo: refaz a tabela e mantém a escolha do cliente.
  function refazerCalculo() {
    if (!ultimoEndereco || !document.getElementById('assembly-info-fullcomm')) return;
    if (typeof updateUIWithAssemblyInfo !== 'function' || typeof window.clearMessages !== 'function') return;

    const anterior = document.getElementById('assembly-checkbox-fullcomm');
    const estavaMarcado = !!(anterior && anterior.checked);

    window.clearMessages();
    updateUIWithAssemblyInfo(ultimoEndereco); // eslint-disable-line no-undef

    const novo = document.getElementById('assembly-checkbox-fullcomm');
    if (estavaMarcado && novo) {
      novo.checked = true;
      window.processAssembly(novo);
    }
  }

  form.addEventListener('change', (evt) => {
    if (evt.target && evt.target.name === 'quantity') refazerCalculo();
  });

  document.addEventListener('on:variant:change', () => setTimeout(refazerCalculo, 0));

  // Garantia final: no envio para o carrinho, grava o valor com a quantidade atual.
  document.addEventListener('submit', (evt) => {
    if (evt.target !== form) return;
    const checkbox = document.getElementById('assembly-checkbox-fullcomm');
    if (checkbox && checkbox.checked) window.processAssembly(checkbox);
  }, true);
})();
